/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface AnnouncementForUserDTO
 */
export interface AnnouncementForUserDTO {
	/**
	 *
	 * @type {string}
	 * @memberof AnnouncementForUserDTO
	 */
	id?: string;
	/**
	 *
	 * @type {string}
	 * @memberof AnnouncementForUserDTO
	 */
	title?: string | null;
	/**
	 *
	 * @type {string}
	 * @memberof AnnouncementForUserDTO
	 */
	description?: string | null;
	/**
	 *
	 * @type {Date}
	 * @memberof AnnouncementForUserDTO
	 */
	validFrom?: Date;
	/**
	 *
	 * @type {Date}
	 * @memberof AnnouncementForUserDTO
	 */
	validTo?: Date;
}

export function AnnouncementForUserDTOFromJSON(
	json: any
): AnnouncementForUserDTO {
	return AnnouncementForUserDTOFromJSONTyped(json, false);
}

export function AnnouncementForUserDTOFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): AnnouncementForUserDTO {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		id: !exists(json, "id") ? undefined : json["id"],
		title: !exists(json, "title") ? undefined : json["title"],
		description: !exists(json, "description") ? undefined : json["description"],
		validFrom: !exists(json, "validFrom")
			? undefined
			: new Date(json["validFrom"]),
		validTo: !exists(json, "validTo") ? undefined : new Date(json["validTo"]),
	};
}

export function AnnouncementForUserDTOToJSON(
	value?: AnnouncementForUserDTO | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		id: value.id,
		title: value.title,
		description: value.description,
		validFrom:
			value.validFrom === undefined ? undefined : value.validFrom.toISOString(),
		validTo:
			value.validTo === undefined ? undefined : value.validTo.toISOString(),
	};
}
